import { getBlueprintTheme } from "../../Blueprints/blueprintThemes";

export function RecommendedBlueprintSkeleton() {
    return (
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 animate-pulse">
            <div className="flex items-start gap-3">
                <div className="bg-gray-200 p-2 rounded-lg w-9 h-9" />
                <div className="flex-1">
                    <div className="bg-gray-200 h-4 w-3/4 rounded mb-2" />
                    <div className="bg-gray-200 h-3 w-full rounded mb-3" />
                    <div className="bg-gray-200 h-3 w-1/2 rounded" />
                </div>
            </div>
        </div>
    );
}

export default function RecommendedBlueprintCard({ blueprint, onClick }) {
    const { Icon, colors } = getBlueprintTheme(blueprint);

    return (
        <div
            className={`bg-gradient-to-br ${colors.gradient} border border-gray-200 ${colors.accent} rounded-lg p-4 hover:shadow-md transition-all cursor-pointer group`}
            onClick={() => onClick(blueprint)}
        >
            <div className="flex items-start gap-3">
                <div className="bg-white/60 p-2 rounded-lg group-hover:bg-white/80 transition-colors flex-shrink-0">
                    <Icon className={`h-5 w-5 ${colors.icon}`} />
                </div>
                <div className="flex-1 min-w-0">
                    <h4 className="font-semibold text-gray-900 mb-1 truncate">
                        {blueprint.name}
                    </h4>
                    <p className="text-sm text-gray-600 line-clamp-2">
                        {blueprint.description || ""}
                    </p>
                </div>
            </div>
        </div>
    );
}
